import React, { useState, useCallback, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import { TextField, Button } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import StoreContext from "../../components/Store/Context";

import {
  Content,
  Main,
  SubTitle,
  Title,
  FormBox,
  FormRow,
  TicketsContainer,
  TicketsRow,
  Block,
  EditSeveralModal,
  EditSeveralModalTitle,
  CloseEditSeveralModal,
  EditSeveralModalSubtitle,
  Overlay,
} from "./orderupdatestore";

import { useNavigate } from "react-router-dom";
import { API_URL } from "../../utils/env";

const OrderUpdateStore = () => {
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const orderId = params.get("id");

  const [ticketsNames, setTicketsNames] = useState([]);
  const [discounts, setDiscounts] = useState([]);
  const [plataforms, setPlataforms] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [blocked, setBlocked] = useState(false);
  const [userBlocking, setUserBlocking] = useState("");
  const [originalOrderRef, setOriginalOrderRef] = useState("");
  const [recordsToUpdate, setRecordsToUpdate] = useState([]);
  const [
    selectRecordsToUpdateModalOpened,
    setSelectRecordsToUpdateModalOpened,
  ] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);

  const { userName, userUsername, userPermissions } = useContext(StoreContext);

  const [formData, setFormData] = useState({
    orderRef: "",
    orderPlataform: "",
    name: "",
    contact: "",
    currency: "",
    country: "",
    discount: "",
    paymentMethod: "",
    ticket1Sector: "",
    ticket1Price: "",
    ticket1Pax: "",
    ticket2Sector: "",
    ticket2Price: "",
    ticket2Pax: "",
    ticket3Sector: "",
    ticket3Price: "",
    ticket3Pax: "",
    ticket4Sector: "",
    ticket4Price: "",
    ticket4Pax: "",
    ticket5Sector: "",
    ticket5Price: "",
    ticket5Pax: "",
  });
  const [formsStatus, setFormsStatus] = useState({});

  const onchange = useCallback(
    (e) => {
      let newFormData = JSON.parse(JSON.stringify(formData));
      newFormData[e.target.name] =
        e.target.type === "checkbox" ? e.target.checked : e.target.value;
      setFormData(newFormData);
      setFormsStatus(Math.random());
    },
    [formData]
  );

  const handleSelectRecordsToUpdate = useCallback(
    (e) => {
      e.preventDefault();

      if ([5].indexOf(userPermissions) !== -1) return;

      fetch(
        `${API_URL}store/getRecordsByOrderRef.php?order-ref=${originalOrderRef}`
      )
        .then((response) => response.json())
        .then((response) => {
          response = response.filter((r) => r.type !== "tickets");
          if (response.length === 0) onSubmit();
          else {
            setRecordsToUpdate(response);
            setSelectRecordsToUpdateModalOpened(true);
            setFormsStatus(Math.random());
          }
        });
    },
    [originalOrderRef, formData, userPermissions]
  );

  const onSubmit = useCallback(
    (e) => {
      e && e.preventDefault();

      let body = formData;
      body.lastEditBy = userName;
      body.createdBy = userName;

      let recordsToUpdate = [];

      if (e) {
        const elements = Array.from(e.target.elements);
        elements.forEach((el) => {
          if (el.tagName === "INPUT") {
            const type = el.id.split("-")[0].trim();
            const id = el.id.split("-")[1].trim();
            if (el.checked) {
              recordsToUpdate.push({
                type,
                id,
              });
            }
          }
        });
      }

      body.recordsToUpdate = recordsToUpdate;

      fetch(`${API_URL}store/tickets/update.php?id=${formData.orderId}`, {
        method: "POST",
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.error) {
            MySwal.fire({
              title: <p>Sucess</p>,
              html: <i>Your order has been updated</i>,
              icon: "success",
            }).then(() => {
              return navigate("/order-list-store");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
    [formData, userName, formsStatus]
  );

  useEffect(() => {
    window.onbeforeunload = function () {
      if (userName && userUsername) {
        const body = {
          page: `${location.pathname}${location.search}`,
          username: userUsername,
          name: userName,
        };
        fetch(`${API_URL}locks/unlock.php`, {
          method: "POST",
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {});
      }
    };
  }, [userName, userUsername, location]);

  useEffect(() => {
    fetch(`${API_URL}store/dropdown-data/tickets.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        let transformedData = [];
        response.forEach((data) => transformedData.push(data.ticket));
        setTicketsNames(transformedData);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}store/dropdown-data/discounts.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        let transformedData = [];
        response.forEach((data) => transformedData.push(data.value));
        setDiscounts(transformedData);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}store/dropdown-data/plataforms.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        let transformedData = [];
        response.forEach((data) => transformedData.push(data.value));
        setPlataforms(transformedData);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_URL}store/dropdown-data/currencies.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        let transformedData = [];
        response.forEach((data) => transformedData.push(data.value));
        setCurrencies(transformedData);
      });
    fetch(`${API_URL}store/dropdown-data/payment-methods.php`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        let transformedData = [];
        response.forEach((data) => transformedData.push(data.value));
        setPaymentMethods(transformedData);
      });
  }, []);

  useEffect(() => {
    if (!orderId) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Order not found!",
      }).then(() => {
        navigate("/order-list-store");
      });
    } else {
      fetch(`${API_URL}store/tickets/list-by-id.php?order_id=${orderId}`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          let newData = {};
          response.forEach((ticket, index) => {
            if (index === 0) {
              newData = {
                orderId: ticket.order_id,
                orderRef: ticket.orderRef,
                orderPlataform: ticket.orderPlataform,
                name: ticket.name,
                contact: ticket.contact,
                currency: ticket.currency,
                country: ticket.country,
                paymentMethod: ticket.paymentMethod,
                discount: ticket.discount,
                ticket1Sector: `${ticket.ticket}`,
                ticket1Price: ticket.price,
                ticket1Pax: ticket.pax,
                ticket1Id: ticket.ticket_id,
                ticket1Canceled: ticket.canceled === "1" ? true : false,
              };
            } else {
              newData[`ticket${index + 1}Sector`] = `${ticket.ticket}`;
              newData[`ticket${index + 1}Price`] = ticket.price;
              newData[`ticket${index + 1}Pax`] = ticket.pax;
              newData[`ticket${index + 1}Id`] = ticket.id;
              newData[`ticket${index + 1}Canceled`] =
                ticket.canceled === "1" ? true : false;
            }
          });
          setFormData({ ...formData, ...newData });
          setOriginalOrderRef(newData.orderRef);
        });
    }
  }, []);

  return (
    <Main>
      <Sidebar></Sidebar>
      <Content blocked={blocked.toString()}>
        {blocked && (
          <Block>
            This page is temporarily blocked because it is being edited by{" "}
            {userBlocking}{" "}
          </Block>
        )}
        <SubTitle>Order</SubTitle>
        <Title>Update - Store</Title>
        <FormBox
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleSelectRecordsToUpdate}
          status={formsStatus}
          blocked={selectRecordsToUpdateModalOpened.toString()}
        >
          <FormRow>
            <TextField
              id="order-ref"
              label="#"
              variant="outlined"
              name="orderRef"
              onChange={onchange}
              value={formData.orderRef}
            />
            <FormControl fullWidth>
              <InputLabel id="order-plataform-label">Plataform</InputLabel>
              <Select
                labelId="order-plataform-label"
                id="order-plataform"
                name="orderPlataform"
                label="Plataform"
                value={formData.orderPlataform}
                onChange={onchange}
              >
                {plataforms.map((plataform) => {
                  return (
                    <MenuItem value={plataform} key={plataform}>
                      {plataform}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </FormRow>
          <FormRow>
            <TextField
              id="name"
              label="Name"
              variant="outlined"
              name="name"
              onChange={onchange}
              value={formData.name}
            />
            <TextField
              id="contact"
              label="Email/whatsapp"
              variant="outlined"
              name="contact"
              onChange={onchange}
              value={formData.contact}
            />
          </FormRow>
          <FormRow>
            <FormControl fullWidth>
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                labelId="currency-label"
                id="currency"
                label="Currency"
                name="currency"
                onChange={onchange}
                value={formData.currency}
              >
                {currencies.map((currency) => {
                  return (
                    <MenuItem value={currency} key={currency}>
                      {currency}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              id="country"
              label="Country"
              variant="outlined"
              name="country"
              onChange={onchange}
              value={formData.country}
            />
          </FormRow>
          <FormRow>
            <FormControl fullWidth>
              <InputLabel id="payment-method-label">Payment Method</InputLabel>
              <Select
                labelId="payment-method-label"
                id="paymentMethod"
                label="PaymentMethod"
                name="paymentMethod"
                onChange={onchange}
                value={formData.paymentMethod}
              >
                {paymentMethods.map((paymentMethod) => {
                  return (
                    <MenuItem value={paymentMethod} key={paymentMethod}>
                      {paymentMethod}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <div></div>
          </FormRow>
          <FormRow column noGap>
            <InputLabel>Products</InputLabel>
            <TicketsContainer>
              <TicketsRow
                canceled={
                  formData.ticket1Canceled &&
                  formData.ticket1Canceled.toString()
                }
              >
                <FormControl fullWidth>
                  <InputLabel id="ticket1-label">Product</InputLabel>
                  <Select
                    labelId="ticket1-label"
                    id="ticket1"
                    label="Ticket"
                    name="ticket1Sector"
                    value={formData.ticket1Sector}
                    onChange={onchange}
                  >
                    {ticketsNames.map((ticket) => {
                      return (
                        <MenuItem value={ticket} key={ticket}>
                          {ticket}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <TextField
                  id="pax1"
                  label="Pax"
                  variant="outlined"
                  name="ticket1Pax"
                  value={formData.ticket1Pax}
                  onChange={onchange}
                  type="number"
                />
                <TextField
                  id="price1"
                  label="Price"
                  variant="outlined"
                  name="ticket1Price"
                  value={formData.ticket1Price}
                  onChange={onchange}
                />
                {formData.ticket1Canceled && <h3>Canceled</h3>}
              </TicketsRow>
              <TicketsRow
                canceled={
                  formData.ticket2Canceled &&
                  formData.ticket2Canceled.toString()
                }
              >
                <FormControl fullWidth>
                  <InputLabel id="ticket2-label">Product</InputLabel>
                  <Select
                    labelId="ticket2-label"
                    id="ticket2"
                    label="Ticket"
                    name="ticket2Sector"
                    value={formData.ticket2Sector}
                    onChange={onchange}
                  >
                    {ticketsNames.map((ticket) => {
                      return (
                        <MenuItem value={ticket} key={ticket}>
                          {ticket}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <TextField
                  id="pax2"
                  label="Pax"
                  variant="outlined"
                  name="ticket2Pax"
                  value={formData.ticket2Pax}
                  onChange={onchange}
                  type="number"
                />
                <TextField
                  id="price2"
                  label="Price"
                  variant="outlined"
                  name="ticket2Price"
                  value={formData.ticket2Price}
                  onChange={onchange}
                />
                {formData.ticket2Canceled && <h3>Canceled</h3>}
              </TicketsRow>
              <TicketsRow
                canceled={
                  formData.ticket3Canceled &&
                  formData.ticket3Canceled.toString()
                }
              >
                <FormControl fullWidth>
                  <InputLabel id="ticket3-label">Product</InputLabel>
                  <Select
                    labelId="ticket3-label"
                    id="ticket3"
                    label="Ticket"
                    name="ticket3Sector"
                    value={formData.ticket3Sector}
                    onChange={onchange}
                  >
                    {ticketsNames.map((ticket) => {
                      return (
                        <MenuItem value={ticket} key={ticket}>
                          {ticket}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <TextField
                  id="pax3"
                  label="Pax"
                  variant="outlined"
                  name="ticket3Pax"
                  value={formData.ticket3Pax}
                  onChange={onchange}
                  type="number"
                />
                <TextField
                  id="price3"
                  label="Price"
                  variant="outlined"
                  name="ticket3Price"
                  value={formData.ticket3Price}
                  onChange={onchange}
                />
                {formData.ticket3Canceled && <h3>Canceled</h3>}
              </TicketsRow>
              <TicketsRow
                canceled={
                  formData.ticket4Canceled &&
                  formData.ticket4Canceled.toString()
                }
              >
                <FormControl fullWidth>
                  <InputLabel id="ticket4-label">Product</InputLabel>
                  <Select
                    labelId="ticket4-label"
                    id="ticket4"
                    label="Ticket"
                    name="ticket4Sector"
                    value={formData.ticket4Sector}
                    onChange={onchange}
                  >
                    {ticketsNames.map((ticket) => {
                      return (
                        <MenuItem value={ticket} key={ticket}>
                          {ticket}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <TextField
                  id="pax4"
                  label="Pax"
                  variant="outlined"
                  name="ticket4Pax"
                  value={formData.ticket4Pax}
                  onChange={onchange}
                  type="number"
                />
                <TextField
                  id="price4"
                  label="Price"
                  variant="outlined"
                  name="ticket4Price"
                  value={formData.ticket4Price}
                  onChange={onchange}
                />

                {formData.ticket4Canceled && <h3>Canceled</h3>}
              </TicketsRow>
              <TicketsRow
                canceled={
                  formData.ticket5Canceled &&
                  formData.ticket5Canceled.toString()
                }
              >
                <FormControl fullWidth>
                  <InputLabel id="ticket5-label">Product</InputLabel>
                  <Select
                    labelId="ticket5-label"
                    id="ticket5"
                    label="Ticket"
                    name="ticket5Sector"
                    value={formData.ticket5Sector}
                    onChange={onchange}
                  >
                    {ticketsNames.map((ticket) => {
                      return (
                        <MenuItem value={ticket} key={ticket}>
                          {ticket}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <TextField
                  id="pax5"
                  label="Pax"
                  variant="outlined"
                  name="ticket5Pax"
                  value={formData.ticket5Pax}
                  onChange={onchange}
                  type="number"
                />
                <TextField
                  id="price5"
                  label="Price"
                  variant="outlined"
                  name="ticket5Price"
                  value={formData.ticket5Price}
                  onChange={onchange}
                />

                {formData.ticket5Canceled && <h3>Canceled</h3>}
              </TicketsRow>
            </TicketsContainer>
          </FormRow>
          <FormRow>
            <FormControl fullWidth>
              <InputLabel id="discount-label">Discount</InputLabel>
              <Select
                labelId="discount-label"
                id="discount"
                label="Discount"
                name="discount"
                onChange={onchange}
                value={formData.discount}
              >
                {discounts.map((discount) => {
                  return (
                    <MenuItem value={discount} key={discount}>
                      {discount}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </FormRow>
          <Button variant="outlined" type="submit">
            Save
          </Button>
        </FormBox>
        <Overlay opened={selectRecordsToUpdateModalOpened.toString()}>
          <EditSeveralModal
            status={formsStatus}
            opened={selectRecordsToUpdateModalOpened.toString()}
          >
            <EditSeveralModalTitle>
              Select others records to update on order-ref {originalOrderRef}
            </EditSeveralModalTitle>
            <EditSeveralModalSubtitle>
              This will update fields "#, Plataform, Name, Email/Whatsapp,
              Country, Currency" in all selected records.
            </EditSeveralModalSubtitle>
            <CloseEditSeveralModal
              onClick={() => setSelectRecordsToUpdateModalOpened(false)}
            />
            <FormBox
              component="form"
              noValidate
              autoComplete="off"
              onSubmit={onSubmit}
            >
              {recordsToUpdate.map((record) => (
                <FormGroup key={`${record.id}-${record.type}`}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={`${record.type} - ${record.id}`}
                        name={record.id}
                        record-type={record.type}
                        inputProps={{
                          "record-type": record.type,
                        }}
                      />
                    }
                    label={`${record.type} ${
                      record.date ? `- ${record.date}` : ""
                    } ${record.sector ? `- ${record.sector}` : ""}`}
                  />
                </FormGroup>
              ))}
              <Button variant="outlined" type="submit">
                Save
              </Button>
            </FormBox>
          </EditSeveralModal>
        </Overlay>
      </Content>
    </Main>
  );
};

export default OrderUpdateStore;
